import {AnalyticsEventHandler} from "../../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../../third-party-services/analytics/analytics-service";
import {BETTING_PROMOTION} from "../bettin-ptomotion.module.consts";
import {BettingPromotionClickAnalyticsEvent} from "../models/betting-promotion.click-analytics.event";

export class BettingPromotionClickAnalyticsHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = BETTING_PROMOTION.ACTION_TYPES.ANALYTICS.onClickHandler;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = BettingPromotionClickAnalyticsEvent
  }
}
